(() => {
  'use strict';
  const endpoint = 'https://playmaker-picks.yehudapeter7.workers.dev';
  const enabled = false;
  const sitekey = '';
  let scriptPromise;
  const messages = {
    'first-order-required': 'ההטבה מיועדת להזמנה ראשונה. אפשר להמשיך עם הדילים שבאתר.',
    'already-requested': 'יש בקשה קודמת למייל הזה. בדוק אם הקוד הגיע, או כתוב לנו בוואטסאפ ונבדוק.',
    'offer-expired': 'תוקף ההטבה הסתיים. הבחירות שלך עדיין כאן.',
    'pick-unavailable': 'אחת הבחירות אינה זמינה כרגע באתר. אפשר לשנות בחירה ולנסות שוב.',
    'eligibility-not-ready': 'הזכאות עדיין מתעדכנת. הבחירות נשמרו, נסה שוב בעוד רגע.',
    'request-processing': 'הבקשה הקודמת עדיין בטיפול. הבחירות נשמרו, נסה שוב בעוד כמה דקות.',
    'too-many-attempts': 'היו כמה ניסיונות ברצף. אפשר לנסות שוב מעט מאוחר יותר.'
  };
  async function requestKey(payload) {
    const identity = JSON.stringify([payload.email.trim().toLowerCase(), payload.selectedProductIds, payload.rewardProductId, payload.reminderConsent, payload.marketingConsent, payload.consentVersion]);
    const bytes = new Uint8Array(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(identity)));
    const key = 'pm-picks-request-' + Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
    try {
      let value = sessionStorage.getItem(key);
      if (!value) { value = crypto.randomUUID(); sessionStorage.setItem(key, value); }
      return value;
    } catch { return memoryKeys.get(key) || (memoryKeys.set(key, crypto.randomUUID()), memoryKeys.get(key)); }
  }
  const memoryKeys = new Map();
  function loadTurnstile() {
    if (window.turnstile) return Promise.resolve();
    if (!scriptPromise) scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true; script.onload = resolve; script.onerror = () => reject(new Error('verification unavailable'));
      document.head.append(script);
    }).catch(e => { scriptPromise = undefined; throw e; });
    return scriptPromise;
  }
  async function verify() {
    if (!sitekey) throw new Error('verification not configured');
    await loadTurnstile();
    return new Promise((resolve, reject) => {
      const box = document.createElement('div');
      box.setAttribute('aria-label', 'אימות הבקשה');
      const host = document.querySelector('.pm3[open] .pm-mail') || document.querySelector('.pm3[open]');
      if (!host) { reject(new Error('popup closed')); return; }
      host.append(box);
      let widget;
      const cleanup = () => { clearTimeout(timer); if (widget !== undefined) window.turnstile.remove(widget); box.remove(); };
      const timer = setTimeout(() => { cleanup(); reject(new Error('verification timeout')); }, 120000);
      widget = window.turnstile.render(box, {
        sitekey, action: 'picks', execution: 'execute',
        callback: token => { cleanup(); resolve(token); },
        'error-callback': () => { cleanup(); reject(new Error('verification failed')); },
        'expired-callback': () => { cleanup(); reject(new Error('verification expired')); }
      });
      window.turnstile.execute(widget);
    });
  }
  async function submit(payload) {
    if (!enabled) return { ok: false, message: 'ההטבה עדיין בבדיקה.' };
    const idempotencyKey = await requestKey(payload);
    const turnstileToken = await verify();
    const response = await fetch(endpoint + '/api/picks', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...payload, idempotencyKey, turnstileToken }),
      signal: AbortSignal.timeout(45000)
    });
    const result = await response.json();
    if (!response.ok || result.ok !== true) return { ok: false, message: messages[result.error] || 'לא הצלחנו להשלים כרגע. הבחירות נשמרו, אפשר לנסות שוב.' };
    if (!result.emailEventAccepted) return { ok: false, message: 'הבקשה נקלטה, והשליחה עדיין בטיפול. הבחירות נשמרו.' };
    return { ok: true };
  }
  window.PlaymakerPicksBackend = { enabled, submit };
})();
